var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<parametermodul-multi-select-ro parameter=\"vm.param_config\" key=\"_selection_\"></parametermodul-multi-select-ro>");;return buf.join("");
}